import type { AuthConfig } from '../types/auth'
import { environment } from './environment'

/**
 * Authentication configuration
 * Uses values from the environment configuration
 */
const authConfig: AuthConfig = {
  // Authentik OAuth2 configuration
  authentikClientId: environment.authentikClientId,
  authentikAuthorizationEndpoint: environment.authentikAuthorizationEndpoint,
  authentikTokenEndpoint: environment.authentikTokenEndpoint,
  authentikUserInfoEndpoint: environment.authentikUserInfoEndpoint,
  authentikLogoutEndpoint: environment.authentikLogoutEndpoint,
  authentikScope: environment.authentikScope,
  cookie: {
    name: environment.auth.cookieName,
    expirationDays: environment.auth.expirationDays
  },
  allowedDomain: environment.auth.allowedDomain
}

export default authConfig
